// Add profile
export const SET_PROFILE_INFO = "SET_PROFILE_INFO";
export const PROFILE_CREATED = "PROFILE_CREATED";
export const ADD_PHOTOS = "ADD_PHOTOS";
export const SAVING_PHOTOS = "SAVING_PHOTOS";
export const PHOTOS_SAVED = "PHOTOS_SAVED";
export const DATA_POLICY = "DATA_POLICY";
export const ENROLLING = "ENROLLING";
export const ENROLLMENT_DONE = "ENROLLMENT_DONE";
export const ENROLLMENT_FAILED = "ENROLLMENT_FAILED";

// Profile images
export const STATUS_INDEXED = "STATUS_INDEXED";
export const STATUS_UNINDEXED = "STATUS_UNINDEXED";
export const STATUS_ARCHIVED = "STATUS_ARCHIVED";
export const STATUS_FAILED = "STATUS_FAILED";
export const STATUS_CAPTURED = "STATUS_CAPTURED";
export const ACTION_INDEX = "ACTION_INDEX";
export const ACTION_UNINDEX = "ACTION_UNINDEX";
export const ACTION_ARCHIVE = "ACTION_ARCHIVE";
export const ACTION_COPY_TO_INDEXED = "ACTION_COPY_TO_INDEXED";
export const ACTION_COPY_TO_UNINDEXED = "ACTION_COPY_TO_UNINDEXED";

// Profile tabs
export const dataPrivacy = "dataPrivacy";
export const details = "details";
export const photos = "photos";
export const events = "events";
export const stats = "stats";
export const historyLog = "historyLog";
export const verification = "verification";
export const temperature = "temperature";
export const notes = "notes";
export const associations = "associations";

// Profile Types
export const PROFILE_TYPE = {
  HUMAN: 1,
  VEHICLE: 2,
  TRAILER: 3,
  CONTAINER: 4,
}

export const excludeAttr = {
  1: [
    31,
    32,
    33,
    34,
    35,
    41,
    20,
    23,
    26,
    24,
    27,
    29,
    39,
    36,
    37,
    38,
    19,
    50,
    194,
    195,
    133,
    134,
    135,
  ],
  2: [18, 42, 53, 89, 45, 46, 44, 50, 41, 52, 47, 104, 19],
  3: [18, 42, 53, 89, 45, 46, 44, 50, 41, 52, 47, 104, 19],
};
